import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DashboardState } from "../types";

const initialState: DashboardState = {
	sidebarIsOpen: true,
	isLoading: false,
	error: null,
};

const dashboardSlice = createSlice({
	name: "dashboard",
	initialState,
	reducers: {
		setSidebarIsOpen: (state, action: PayloadAction<boolean>) => {
			state.sidebarIsOpen = action.payload;
		},
		toggleSidebar: (state) => {
			state.sidebarIsOpen = !state.sidebarIsOpen;
		},
		openSidebar: (state) => {
			state.sidebarIsOpen = true;
		},
		closeSidebar: (state) => {
			state.sidebarIsOpen = false;
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.isLoading = action.payload;
		},
		setError: (state, action: PayloadAction<string | null>) => {
			state.error = action.payload;
		},
		clearError: (state) => {
			state.error = null;
		},
	},
});

export const {
	setSidebarIsOpen,
	toggleSidebar,
	openSidebar,
	closeSidebar,
	setLoading,
	setError,
	clearError,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
